<template>
  <div class="pay-dialog" v-if="showDialog">
    <transition name="pay-dialog-fade">
      <div class="pay-dialog-bg" v-if="showDialog" @click="clickCancel"></div>
    </transition>
    <transition name="pay-dialog-show">
      <div class="pay-dialog-box" v-if="showDialog">
        <h4 class="pay-dialog-close">
          <span class="less-grey" @click="clickCancel">✕</span>
        </h4>
        <h4 class="pay-dialog-main pay-dialog-main-title" >请选择支付方式</h4>
        <div class="pay-dialog-list">
          <div class="pay-dialog-item flex" @click="changeType('alipay')">
            <p class="flex-1" v-if="alipay"  >
              <img class="pay-dialog-item-img" src="../assets/icon/alipay.png">支付宝
            </p>
            <img v-if="selected === 'alipay'"
            class="pay-dialog-item-img" src="../assets/icon/selected.png" >
            <img  v-else class="pay-dialog-item-img" src="../assets/icon/unselected.png" >
          </div>
          <div class="pay-dialog-item flex" v-if="wechat" @click="changeType('wechat_web')">
            <p class="flex-1">
              <img class="pay-dialog-item-img" src="../assets/icon/wechat.png">微信
            </p>
            <img v-if="selected === 'wechat_web'"
            class="pay-dialog-item-img" src="../assets/icon/selected.png" >
            <img  v-else class="pay-dialog-item-img" src="../assets/icon/unselected.png" >
          </div>
        </div>
        <div class="s4s-btn"
          @click="clickConfirm">立即付款</div>
        <!-- <div class="pay-dialog-button" style="margin-top:40px">
          <div class="pay-dialog-confirm-button"
          @click="clickConfirm">立即付款</div>
        </div> -->
      </div>
    </transition>
  </div>
</template>
<script>
export default{
  data() {
    return {
    };
  },
  props: ['showDialog', 'selected', 'wechat', 'alipay'],
  methods: {
    clickCancel() {
      this.$emit('cancel');
    },
    clickConfirm() {
      this.$emit('confirm');
    },
    confirmHide() {
      this.$emit('confirmhide');
    },
    changeType(type) {
      this.$emit('change', type);
    },
  },
};
</script>
<style lang="scss">

.pay-dialog {
  .s4s-btn {
    margin: 40px 15px 20px;
    width: auto;
  }
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  &-bg {
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.4);
  }
  &-box {
    width: 90%;
    position: absolute;
    top: 40%;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);
    background-color: #fff;
    border-radius: 2px;
    line-height: 1.5;
    text-align: center;
  }
  &-close {
    text-align:left;
    padding:15px 0 0 15px;
    .less-grey {
      font-size:18px
    }
  }
  &-item {
    padding: 13px 0;
    border-bottom: 1px solid #F2F2F2;
    &-img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  &-list {
    text-align: left;
    padding: 0 15px;
  }
  &-main {
    text-align: center;
    padding: 0 19px 15px;
    color:#333;
    margin-top: -10px;
    &-content {

    }
    &-title {
      font-size: 16px;
    }
  }
  &-button {
    overflow: hidden;
    border-top: 1px solid #EEE;
    font-size: 16px;
    line-height: 44px;
    display: flex;
  }
  &-confirm {
    &-cancel {

      color: #3ba3f2;
      flex:1;
      border-right: 1px solid #EEE;
      margin-right: -1px;
    }
    &-button {
      flex:1;
      color: #3ba3f2;
      border-right: .5px solid #eaeaea;
    }
  }
  .pay-dialog-show-enter-active, .pay-dialog-fade-enter-active {
    transition: all .3s ease;
  }
  .pay-dialog-show-leave-active, .pay-dialog-fade-leave-active {
    transition: all .3s ease;
  }
  .pay-dialog-show-enter, .pay-dialog-show-leave-active {
    top: -35%;
  }
  .pay-dialog-fade-enter, .pay-dialog-fade-leave-active {
    opacity: 0;
  }
}
</style>

